import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from './../../services/common_service/common.service';

@Injectable({
  providedIn: 'root'
})
export class AppLayoutResolverService  {
  constructor(private commonService: CommonService) { }
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    // rclcData will be called based on resolver
    const rclcData = localStorage.getItem("rclcData");
    if (!rclcData) {
      return this.commonService.mapRCLCList().pipe(
        catchError(() => {
          return of('No data');
        })
      );
    }

  }
}